export default __webpack_public_path__ + "static/media/erweima.45288679.png";